import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const TransferRefText = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`
